export const GET_SHOPPINGS = 'getShoppings'
export const GET_SHOPPING = 'getShopping'
export const GET_REPORTS_BY_DATE = 'getReportsByDate'
export const CONFIRM_PAYMENT = 'confirmPayment'
export const CONFIRM_DELIVERY = 'confirmDelivery'
export const CONFIRM_SHIPPING = 'confirmShipping'
export const DENY_SHOPPING = 'denyShopping'
export const CANCEL_SHOPPING = 'cancelShopping'